import type { CollectCommentsMode, NarrativeFormData } from '../components/Forms/types';
import { canCollectComments } from './contentTypes';

export const COLLECT_COMMENTS_MIN_VALUE = 1;
export const COLLECT_COMMENTS_MAX_PERCENT = 100;

type CollectCommentsFormFields = Pick<
  NarrativeFormData,
  'collectCommentsMode' | 'collectCommentsPerPostLimit' | 'collectCommentsSamplePercent'
>;

type CollectCommentsParams = {
  collect_comments_per_post_limit?: number | null;
  collect_comments_sample_percent?: number | null;
};

/** Case parameters (API) → form fields. Absent limit and percent means "All". */
export const getCollectCommentsFormFields = (
  params: CollectCommentsParams = {},
): CollectCommentsFormFields => {
  const limit = params.collect_comments_per_post_limit ?? null;
  const percent = params.collect_comments_sample_percent ?? null;
  const mode: CollectCommentsMode = limit ? 'NUMBER' : percent ? 'PERCENT' : 'ALL';

  return {
    collectCommentsMode: mode,
    collectCommentsPerPostLimit: limit,
    collectCommentsSamplePercent: percent,
  };
};

/** Form fields → case parameters (API). Only the value of the selected mode is sent. */
export const getCollectCommentsParameters = (
  data: Pick<
    NarrativeFormData,
    'collectCommentsToPosts' | 'contentTypes' | 'sourceTypes' | keyof CollectCommentsFormFields
  >,
) => {
  const collect =
    Boolean(data.collectCommentsToPosts) && canCollectComments(data.contentTypes, data.sourceTypes);

  return {
    collect_comments_to_posts: collect,
    collect_comments_per_post_limit:
      collect && data.collectCommentsMode === 'NUMBER' ? data.collectCommentsPerPostLimit ?? null : null,
    collect_comments_sample_percent:
      collect && data.collectCommentsMode === 'PERCENT' ? data.collectCommentsSamplePercent ?? null : null,
  };
};
